import React, { useEffect, useRef, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import Select from 'react-select';
import '../../../assets/css/overview-addnew-milestones.css';
import { fetchProjectTeamMembers, fetchProjectTeamMemberswithNone } from '../../../utils/fetchData';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';
import {
  calculateDateDiff,
  cleanFormattedPricing,
  clearLocalStorage,
  daysOptions,
  formatDate,
  formatOptions,
  formatPricing,
  getDaysBetweenDates,
  priceLimit,
  selectLoader,
  userNameLimit,
  validateMilestoneFields,
  validateTextInput,
  validPricing
} from '../../../utils/Helpers';
import APIServices from '../../../services/APIServices';
import { useNavigate, useParams } from 'react-router-dom';
import previewIcon from '../../../assets/img/preview-icon.png';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { useStore } from 'hooks/useStore';
import SaveModalKanban from 'components/SaveModalKanban';
const AddTemplate = ({
  currentTab,
  selectedTemplateId = '',
  setSelectedTemplateId,
  projectDetails,
  companyId = '',
  setMilestoneTab,
  setProjectStatus,
  editProjectDetails,
  isWithContract,
  contractMilestones
}) => {
  const [store, setStore] = useStore();
  const descriptionRefs = useRef([]);
  const inputRefs = useRef([]);
  const projectSubmissionInProgressRef = useRef(false);
  const templateSubmissionInProgressRef = useRef(false);
  const navigate = useNavigate();
  const { projectId: projectIdFromParams } = useParams();
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);
  const [milestoneLoadError, setMilestoneLoadError] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [error, setError] = useState('');
  const [isEditing, setEditing] = useState(false);
  const [errors, setErrors] = useState({}); // Track errors for milestones
  const [totalDuration, setTotalDuration] = useState(null);
  const [templateError, setTemplateError] = useState('');
  const [templateId, setTemplateId] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [assigneeOptions, setAssigneeOptions] = useState([]);
  const [initialTemplateName, setInitialTemplateName] = useState('');
  const [initialMilestones, setInitialMilestones] = useState([]);
  const [isUpdateEnable, setUpdateEnable] = useState(true);
  const [modals, setModals] = useState({
    addProject: false
  });
  const [milestones, setMilestones] = useState([
    {
      assigneeId: null,
      name: '',
      description: '',
      daysToComplete: null,
      signOffRequired: true,
      signOffTime: '',
      feedbackRequest: true,
      // feedbackRequestTime: "",
      paymentDue: null,
      paymentDueRequired: true,
      isProjectAndKanbanBoardCard: false,
      sequence: 1
    }
  ]);
  const [, setMilestonesToDelete] = useState([]);

  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };

  useEffect(() => {
    if (contractMilestones && contractMilestones.length) {
      const mapped = contractMilestones.map((m, index) => {
        const formattedDueDate = m.dueDate ? formatDate(m.dueDate, 'YYYY-MM-DD') : '';

        return {
          name: m.name,
          description: '',
          daysToComplete: getDaysBetweenDates(startDate, m.dueDate), // ✅ added
          signOffRequired: false,
          signOffTime: '',
          feedbackRequest: false,
          paymentDue: m.paymentDue || '',
          paymentDueRequired: true,
          assigneeId: null,
          sequence: index + 1,
          dueDate: formattedDueDate
        };
      });

      setMilestones(mapped);
    }
  }, [contractMilestones, startDate]);

  useEffect(() => {
    milestones.forEach((_, idx) => {
      const el = descriptionRefs.current[idx];

      if (el) {
        console.log(el.scrollHeight);
        if (el.scrollHeight > 75) {
          el.style.height = 'auto';
          el.style.height = `${Math.min(el.scrollHeight, 1.5 * 16 * 8) + 2}px`;
        }
      }
    });
  }, [milestones]); // rerun when milestones change

  //code for the milestones reorder drag and drop:

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) return;

    // const reordered = reorder(milestones, source.index, destination.index);
    // console.log(reordered);
    const reordered = reorder(milestones, source.index, destination.index).map((item, idx) => ({
      ...item,
      sequence: idx + 1 // 1-based index; use 0 if preferred
    }));
    setMilestones(reordered);
  };

  useEffect(() => {
    if (projectDetails) {
      console.log('newwww', projectDetails);

      setProjectId(projectDetails._id);
      setStartDate(new Date(projectDetails.startDate || new Date()).toLocaleDateString('en-CA'));
      setEndDate(new Date(projectDetails.endDate || new Date()).toLocaleDateString('en-CA'));
      fetchProjectTeamMemberswithNone(projectDetails._id, setAssigneeOptions, 'user1');
    }
  }, [projectDetails]);

  useEffect(() => {
    console.log(editProjectDetails);
    console.log(editProjectDetails.endDate);

    if (editProjectDetails) {
      setStartDate(new Date(editProjectDetails.startDate || new Date()).toLocaleDateString('en-CA'));
      setEndDate(new Date(editProjectDetails.endDate || new Date()).toLocaleDateString('en-CA'));
    }
  }, [editProjectDetails]);

  useEffect(() => {
    if (projectIdFromParams && currentTab == 5) {
      setEditing(true);
      setProjectId(projectIdFromParams);
      fetchProjectTeamMemberswithNone(projectIdFromParams, setAssigneeOptions, 'user1');
      fetchMilestones(projectIdFromParams);
    }
  }, [projectIdFromParams, currentTab]);

  useEffect(() => {
    const dateDiff = calculateDateDiff(startDate, endDate);
    setTotalDuration(dateDiff);
    if (selectedTemplateId) {
      setTemplateId(selectedTemplateId);
      fetchTemplateData(selectedTemplateId);
      // setEditing(true);
    }
  }, [selectedTemplateId]);

  const fetchTemplateData = async (templateId) => {
    setPageLoading(true);
    try {
      const response = await APIServices.get(`/template/${templateId}`); // Adjust the URL as necessary
      if (response.milestones) {
        setMilestones(response.milestones);
        setTemplateName(response.name);
        setInitialMilestones(response.milestones);
        setInitialTemplateName(response.name);
        setUpdateEnable(false);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setPageLoading(false);
    }
  };

  const fetchMilestones = async (projectId) => {
    setPageLoading(true);
    setMilestoneLoadError('');
    try {
      const response = await APIServices.get(`/project-milestone?projectId=${projectId}`); // Adjust the URL as necessary
      if (response.length > 0) {
        setMilestones(response);
      }
      // if (response.milestones) {
      //   setMilestones(response.milestones);
      // }
    } catch (error) {
      setMilestoneLoadError(
        error?.response?.data?.message || error?.message || 'Unable to load milestones. Please try again.'
      );
    } finally {
      setPageLoading(false);
    }
  };

  const checkMilestoneDiff = () => {
    if (milestones == initialMilestones && initialTemplateName == templateName) {
      setUpdateEnable(false);
    } else {
      setUpdateEnable(true);
    }
  };

  useEffect(() => {
    checkMilestoneDiff();
  }, [milestones, templateName]);

  const addMilestone = () => {
    if (validateMilestoneFields(milestones, setErrors, true)) {
      setMilestones([
        ...milestones,
        {
          assigneeId: null,
          name: '',
          description: '',
          daysToComplete: '',
          signOffRequired: true,
          signOffTime: '',
          feedbackRequest: true,
          // feedbackRequestTime: "",
          paymentDue: '',
          paymentDueRequired: true,
          isProjectAndKanbanBoardCard: false,
          sequence: milestones.length + 1
        }
      ]);
      setTimeout(() => {
        const newIndex = milestones.length;
        inputRefs.current[newIndex]?.focus();
      }, 0);
    }
    saveFormDataToLocalStorage();
  };

  const deleteMilestone = (index, milestoneId = '') => {
    const updatedMilestones = milestones.filter((_, i) => i !== index);
    setMilestones(updatedMilestones);

    if (milestoneId) {
      setMilestonesToDelete((previousIds) => [...previousIds, milestoneId]);
    }
    saveFormDataToLocalStorage(updatedMilestones);
  };

  const handleInputChange = (index, field, value) => {
    let formattedValue = 0;
    const dateDiff = calculateDateDiff(startDate, endDate);
    if (field === 'paymentDue') {
      // Only allow digits and period for decimal values
      value = validPricing(value);
      // Format the number with commas
      formattedValue = formatPricing(value);
      // console.log(value);
    }
    setTotalDuration(dateDiff);
    const updatedMilestones = milestones.map((milestone, i) =>
      i === index
        ? {
            ...milestone,
            [field]: field === 'paymentDue' ? formattedValue : value
          }
        : milestone
    );
    setMilestones(updatedMilestones);
    // Clear errors for the current field when it's updated
    setErrors((prevErrors) => ({
      ...prevErrors,
      [index]: { ...prevErrors[index], [field]: false }
    }));
    saveFormDataToLocalStorage();
  };

  const backToTemplate = () => {
    setSelectedTemplateId('');
    setMilestoneTab('select');
    setEditing(false);
  };

  const validateName = () => {
    let hasError = false;
    if (!validateTextInput(templateName).isValid && !isEditing) {
      if (!validateTextInput(templateName).cleanedValue) {
        setTemplateError('Please enter Template name.');
      } else {
        setTemplateError(validateTextInput(templateName).message);
      }
      hasError = true;
    }
    return hasError;
  };

  const createProject = async (saveTemplate = false) => {
    if (saveTemplate && templateSubmissionInProgressRef.current) {
      return;
    }

    if (!saveTemplate && projectSubmissionInProgressRef.current) {
      return;
    }

    if (saveTemplate) {
      if (validateName()) {
        toggleModal('addProject', false);
        return;
      }
    }
    const dateDiff = calculateDateDiff(startDate, endDate);
    if (validateMilestoneFields(milestones, setErrors, saveTemplate, dateDiff)) {
      if (saveTemplate) {
        templateSubmissionInProgressRef.current = true;
        setLoadingTemplate(true);
      } else {
        projectSubmissionInProgressRef.current = true;
        setLoading(true);
      }
      let milestoneData = milestones.map((milestone) => {
        const milestoneObj = {
          name: milestone.name,
          description: milestone.description,
          startDate: startDate,
          daysToComplete: Number(milestone.daysToComplete),
          signOffTime: milestone.signOffTime || 0,
          signOffRequired: milestone.signOffRequired,
          // feedbackRequestTime: milestone.feedbackRequestTime,
          feedbackRequest: milestone.feedbackRequest,
          assigneeId: milestone.assigneeId,
          paymentDue: cleanFormattedPricing(milestone.paymentDue),
          paymentDueRequired: milestone.paymentDueRequired,
          isProjectAndKanbanBoardCard: milestone.isProjectAndKanbanBoardCard,
          projectId: projectId,
          sequence: milestone?.sequence
        };
        if (isEditing) {
          if (milestone._id) milestoneObj._id = milestone?._id || '';
          if (milestone.status) milestoneObj.status = milestone?.status?._id || '';
          if (milestone.kbDueDate) milestoneObj.kbDueDate = milestone?.kbDueDate || '';
          if (milestone.startDate) milestoneObj.startDate = milestone?.startDate || '';
        }
        return milestoneObj;
      });
      let milestonePayload = {
        milestones: milestoneData
      };

      let saveTemplatePayload = {
        name: templateName, // Use the template name from state
        companyId: companyId || '',
        milestones: milestones.map((milestone) => ({
          // ...(milestone._id && { _id: milestone._id }),
          name: milestone.name,
          description: milestone.description,
          daysToComplete: Number(milestone.daysToComplete),
          signOffTime: milestone.signOffTime || 0,
          signOffRequired: milestone.signOffRequired,
          // feedbackRequestTime: milestone.feedbackRequestTime,
          feedbackRequest: milestone.feedbackRequest,
          paymentDue: cleanFormattedPricing(milestone.paymentDue),
          paymentDueRequired: milestone.paymentDueRequired,
          isProjectAndKanbanBoardCard: milestone.isProjectAndKanbanBoardCard,
          sequence: milestone?.sequence
          // projectId: projectId,
        }))
      };

      try {
        if (saveTemplate) {
          if (!projectIdFromParams) {
            const templateResponse = isEditing
              ? await APIServices.put(`/template/${templateId}`, saveTemplatePayload)
              : await APIServices.post('/template', saveTemplatePayload);
            if (templateResponse.message) {
              if (saveTemplate) {
                appToast(templateResponse.message, TOAST_TYPE.SUCCESS);
                setMilestoneTab('select');
              }
            } else {
              appToast(templateResponse.data.message, TOAST_TYPE.ERROR);
            }
          }
        } else {
          console.log(milestoneData, 'milestoneData');

          const response = isEditing
            ? await APIServices.put(`/project-milestone/${projectId}`, milestonePayload)
            : await APIServices.post('/project-milestone', milestoneData.length == 0 ? { projectId } : milestoneData);
          // console.log(response);
          if (response.message) {
            appToast(response.message, TOAST_TYPE.SUCCESS);
            if (projectIdFromParams) {
              navigate(`/project-board/project/${projectIdFromParams}`, {
                state: {
                  // Ensure Kanban opens with Overview tab selected.
                  boardViewType: 'overview',
                  isProjectRelatedBoard: true,
                  projectId: projectIdFromParams,
                  isFromHome: true
                }
              });
            } else {
              navigate(`/project-board/project/${projectId}`, {
                state: {
                  // Ensure Kanban opens with Overview tab selected.
                  boardViewType: 'overview',
                  isProjectRelatedBoard: true,
                  projectId: projectId,
                  isFromHome: true
                }
              });

              // navigate("/");
            }
            setProjectStatus('');
          } else {
            appToast(response.data.message, TOAST_TYPE.ERROR);
          }
        }
      } catch (error) {
        console.error('Form submission error:', error);
        if (!saveTemplate) {
          const message =
            error?.response?.data?.message || error?.message || 'Unable to save the project milestones. Please try again.';
          appToast(message, TOAST_TYPE.ERROR);
        }
      } finally {
        if (saveTemplate) {
          templateSubmissionInProgressRef.current = false;
        } else {
          projectSubmissionInProgressRef.current = false;
        }
        setLoading(false);
        setLoadingTemplate(false);
      }
    } else {
      // validateName();
      // Find the first element with the error class
      toggleModal('addProject', false);
      const firstErrorElement = document.querySelector('.form-invalid');
      if (firstErrorElement) {
        // Scroll to the first error field
        firstErrorElement.scrollIntoView({
          behavior: 'smooth', // Smooth scrolling effect
          block: 'center' // Scroll so the element is centered in the view
        });

        // Optionally, focus the first error element
        firstErrorElement.focus();
      }
    }
    // Make API call or handle the payload as needed
  };

  //functionalities to get the existing data from local storage.
  const loadFormDataFromLocalStorage = () => {
    const savedData = localStorage.getItem('formData');
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setTemplateName(parsedData.templateName || '');
      setMilestones(parsedData.milestones || []);
    }
  };

  const saveFormDataToLocalStorage = (milestoneDraft = milestones) => {
    const formData = {
      templateName,
      milestones: milestoneDraft
    };
    localStorage.setItem('formData', JSON.stringify(formData));
  };

  useEffect(() => {
    window.addEventListener('beforeunload', clearLocalStorage);

    loadFormDataFromLocalStorage();

    // Cleanup event listener
    return () => {
      window.removeEventListener('beforeunload', clearLocalStorage);
    };
  }, []);

  if (pageLoading) {
    return <div className="nodata-loader"> {selectLoader(70)}</div>;
  }

  if (milestoneLoadError) {
    return (
      <div className="milestone-load-error" role="alert">
        <h3>Unable to load Milestones</h3>
        <p>{milestoneLoadError}</p>
        <button type="button" className="btn-black" onClick={() => fetchMilestones(projectIdFromParams || projectId)}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="milestone-add pt-lg-5 mb-3">
      <div className="row">
        <div className="col-lg-7 col-md-12 pb-3">
          <div className="scroll-smooth">
            {/* <h2 className="text-center mb-4">Milestones</h2> */}
            <div className="card-bg-white">
              {/* {!isEditing && (
                <>
                  <h4 className="text-center mt-sm-4">Write your template name</h4>
                  <div className="add-milestone add-milestone2 p-0 mb-4 br-10">
                    <div className="mb-3 form-cover">
                      <input
                        maxLength={userNameLimit}
                        type="text"
                        className={`form-control ${templateError ? 'form-invalid' : ''} `}
                        placeholder="Enter Template name"
                        value={templateName}
                        onChange={(e) => {
                          setTemplateName(e.target.value);
                          setTemplateError('');
                        }}
                      />
                      {templateError && <div className="error-message">{templateError}</div>}
                    </div>
                  </div>
                </>
              )} */}

              {milestones.map((milestone, index) => (
                <div key={index} className="create-project-card">
                  <form className="add-milestone p-0 mb-0 br-10">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="milestone-stepCover">
                          <span>{index + 1}</span>
                          <div className="form-cover form-cover-updated">
                            <h3 className="text-center">Milestone {index + 1}</h3>
                            <input
                              maxLength={userNameLimit}
                              type="text"
                              className={`form-control ${errors[index]?.name ? 'form-invalid' : ''}`}
                              placeholder="Enter milestone name"
                              value={milestone.name}
                              onChange={(e) => handleInputChange(index, 'name', e.target.value)}
                              ref={(el) => (inputRefs.current[index] = el)}
                            />
                            {errors[index]?.name && <div className="error-message">{errors[index]?.name}</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <h3 className="text-center">Description {index + 1}</h3>
                        <div className="mb-3 form-cover">
                          <textarea
                            ref={(el) => (descriptionRefs.current[index] = el)}
                            className={`form-control custom-textarea ${errors[index]?.description ? 'form-invalid' : ''} `}
                            // ${
                            //   milestone?.isAddendum ? 'disabled-color' : ''
                            // }
                            disabled={milestone?.isAddendum}
                            placeholder="Description"
                            value={milestone.description}
                            onChange={(e) => {
                              const el = e.target;
                              const maxHeight = 1.5 * 16 * 8; // 8 lines
                             
                              handleInputChange(index, 'description', el.value);
                            }}
                          />
                          {errors[index]?.description && (
                            <div className="error-message">{errors[index]?.description}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    {isEditing &&
                    (milestone?.isAddendum || (milestone.status && milestone?.status?.value != 'todo')) ? (
                      <div className="milestone-cardCver">
                        <div className="row">
                          <div className="col-md-6 col-lg-6">
                            <div className="mb-2 form-cover">
                              <div
                                className={`form-group-box-cover ${errors[index]?.daysToComplete ? 'form-invalid' : ''}`}>
                                <label className="label-title d-flex align-items-center mb-0 me-3">
                                  Days to completion
                                </label>
                                <input
                                  type="text"
                                  placeholder="Days"
                                  className={`form-payment `}
                                  value={milestone.daysToComplete}
                                  disabled={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-6">
                            <div className="mb-2 form-cover">
                              <div
                                className={` form-group-box-cover ${errors[index]?.signOffTime ? 'form-invalid' : ''}`}>
                                <div className={`form-check checkbox label-title d-flex align-items-center me-3`}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkboxSignOff${index}`}
                                    checked={milestone.signOffRequired}
                                    onChange={(e) => handleInputChange(index, 'signOffRequired', e.target.checked)}
                                  />
                                  <label className="form-check-label mb-0" htmlFor={`checkboxSignOff${index}`}>
                                    Sign-off required
                                  </label>
                                </div>
                                <input
                                  type="text"
                                  className="form-payment"
                                  placeholder="Days"
                                  maxLength={40}
                                  value={milestone?.signOffTime || ''}
                                  onChange={(e) => {
                                    let value = e.target.value;
                                    const validValue = value.replace(/[^0-9.]/g, '');
                                    // Allow only digits and decimal points
                                    const regex = /^[0-9]*\.?[0-9]*%?$/;
                                    if (regex.test(validValue)) {
                                      handleInputChange(index, 'signOffTime', validValue);
                                    }
                                  }}
                                />
                              </div>
                              {errors[index]?.signOffTime && (
                                <div className="error-message">{errors[index]?.signOffTime}</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-lg-6">
                            <div className="mb-2 form-cover">
                              <div
                                className={` form-group-box-cover ${
                                  errors[index]?.feedbackRequestTime ? 'form-invalid' : ''
                                }`}>
                                <div className="form-check checkbox label-title d-flex align-items-center me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkboxFeedbackOff${index}`}
                                    checked={milestone.feedbackRequest}
                                    onChange={(e) => handleInputChange(index, 'feedbackRequest', e.target.checked)}
                                  />
                                  <label className="form-check-label mb-0" htmlFor={`checkboxFeedbackOff${index}`}>
                                    Feedback request
                                  </label>
                                </div>
                              </div>
                              {errors[index]?.feedbackRequestTime && (
                                <div className="error-message">{errors[index]?.feedbackRequestTime}</div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-6">
                            <div className="mb-2 form-cover">
                              <div className={` form-group-box-cover`}>
                                <div className="form-check checkbox label-title d-flex align-items-center me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`isProjectAndKanbanBoardCard${index}`}
                                    checked={milestone.isProjectAndKanbanBoardCard}
                                    onChange={(e) =>
                                      handleInputChange(index, 'isProjectAndKanbanBoardCard', e.target.checked)
                                    }
                                  />
                                  <label
                                    className="form-check-label mb-0"
                                    htmlFor={`isProjectAndKanbanBoardCard${index}`}>
                                    Display on Kanban board
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-6 col-lg-6">
                            <div className="mb-2 form-cover">
                              <div
                                className={` form-group-box-cover ${errors[index]?.assigneeId ? 'form-invalid' : ''}`}>
                                <label className="label-title d-flex align-items-center mb-0 me-3">Assignee</label>
                                <Select
                                  options={assigneeOptions}
                                  value={assigneeOptions.find(
                                    (option) =>
                                      option.value === milestone.assigneeId ||
                                      option.value === milestone?.assigneeId?._id
                                  )}
                                  onChange={(option) => handleInputChange(index, 'assigneeId', option.value)}
                                  placeholder="Select"
                                  styles={{
                                    container: (base) => ({
                                      ...base,
                                      maxWidth: '150px'
                                    })
                                  }}
                                />
                              </div>
                              {errors[index]?.assigneeId && (
                                <div className="error-message">{errors[index]?.assigneeId}</div>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-lg-6">
                            <div className="mb-2 form-cover">
                              <div
                                className={`form-group-box-cover  ${errors[index]?.paymentDue ? 'form-invalid' : ''}`}>
                                <div className="form-check checkbox label-title d-flex align-items-center me-3">
                                  <input
                                    // disabled={true}
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkboxPayment${index}`}
                                    checked={milestone.paymentDueRequired}
                                    // onChange={(e) => handleInputChange(index, 'paymentDueRequired', e.target.checked)}
                                  />
                                  <label className="form-check-label mb-0" htmlFor={`checkboxPayment${index}`}>
                                    Payment Due
                                  </label>
                                </div>
                                <div className="form-payment-cover">
                                  <input
                                    type="text"
                                    className="form-payment"
                                    placeholder="$"
                                    maxLength={priceLimit}
                                    value={milestone?.paymentDue ? `$ ${milestone.paymentDue}` : ''}
                                    disabled={true}
                                  />
                                  {/* <p>%</p> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className="mb-3 form-cover">
                          <div className={` form-group-box-cover ${errors[index]?.assigneeId ? 'form-invalid' : ''}`}>
                            <div className={`kanban-switch`}>
                              <label className="label-title d-flex align-items-center mb-0 me-3">
                                Internal Project
                              </label>
                              <div className="form-switch">
                                <input
                                  type="checkbox"
                                  checked={milestone.isProjectAndKanbanBoardCard}
                                  onChange={(e) => handleInputChange(index, 'isProjectAndKanbanBoardCard', e.target.checked)}
                                  name="isProjectAndKanbanBoardCard"
                                  hidden="hidden"
                                  id="isProjectAndKanbanBoardCard"
                                  disabled={true}
                                />
                                <label className=" label-title switch" htmlFor="isProjectAndKanbanBoardCard"></label>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    ) : (
                      <>
                        <div className="milestone-cardCver">
                          <div className="row">
                            <div className="col-md-6 col-lg-6">
                              <div className="mb-2 form-cover">
                                <div
                                  className={`form-group-box-cover ${errors[index]?.daysToComplete ? 'form-invalid' : ''}`}>
                                  <label className="label-title d-flex align-items-center mb-0 me-3">
                                    Days to completion
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Days"
                                    className={`form-payment `}
                                    value={milestone.daysToComplete}
                                    onChange={(e) => {
                                      let value = e.target.value;
                                      const validValue = value.replace(/[^0-9.]/g, '');
                                      // Allow only digits and decimal points
                                      const regex = /^[0-9]*\.?[0-9]*%?$/;

                                      if (regex.test(validValue)) {
                                        handleInputChange(index, 'daysToComplete', validValue);
                                      }
                                    }}
                                  />
                                </div>
                                {errors[index]?.daysToComplete && (
                                  <div className="error-message">{errors[index]?.daysToComplete}</div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-6">
                              <div className="mb-2 form-cover">
                                <div
                                  className={` form-group-box-cover ${errors[index]?.signOffTime ? 'form-invalid' : ''}`}>
                                  <div className={`form-check checkbox label-title d-flex align-items-center me-3`}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`checkboxSignOff${index}`}
                                      checked={milestone.signOffRequired}
                                      onChange={(e) => handleInputChange(index, 'signOffRequired', e.target.checked)}
                                    />
                                    <label className="form-check-label mb-0" htmlFor={`checkboxSignOff${index}`}>
                                      Sign-off required
                                    </label>
                                  </div>
                                  <input
                                    type="text"
                                    className="form-payment"
                                    placeholder="Days"
                                    maxLength={40}
                                    value={milestone?.signOffTime || ''}
                                    onChange={(e) => {
                                      let value = e.target.value;
                                      const validValue = value.replace(/[^0-9.]/g, '');
                                      // Allow only digits and decimal points
                                      const regex = /^[0-9]*\.?[0-9]*%?$/;
                                      if (regex.test(validValue)) {
                                        handleInputChange(index, 'signOffTime', validValue);
                                      }
                                    }}
                                  />
                                </div>
                                {errors[index]?.signOffTime && (
                                  <div className="error-message">{errors[index]?.signOffTime}</div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 col-lg-6">
                              <div className="mb-2 form-cover">
                                <div
                                  className={` form-group-box-cover ${
                                    errors[index]?.feedbackRequestTime ? 'form-invalid' : ''
                                  }`}>
                                  <div className="form-check checkbox label-title d-flex align-items-center me-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`checkboxFeedbackOff${index}`}
                                      checked={milestone.feedbackRequest}
                                      onChange={(e) => handleInputChange(index, 'feedbackRequest', e.target.checked)}
                                    />
                                    <label className="form-check-label mb-0" htmlFor={`checkboxFeedbackOff${index}`}>
                                      Feedback request
                                    </label>
                                  </div>
                                </div>
                                {errors[index]?.feedbackRequestTime && (
                                  <div className="error-message">{errors[index]?.feedbackRequestTime}</div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-6">
                              <div className="mb-2 form-cover">
                                <div className={` form-group-box-cover`}>
                                  <div className="form-check checkbox label-title d-flex align-items-center me-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`isProjectAndKanbanBoardCard${index}`}
                                      checked={milestone.isProjectAndKanbanBoardCard}
                                      onChange={(e) =>
                                        handleInputChange(index, 'isProjectAndKanbanBoardCard', e.target.checked)
                                      }
                                    />
                                    <label
                                      className="form-check-label mb-0"
                                      htmlFor={`isProjectAndKanbanBoardCard${index}`}>
                                      Display on Kanban board
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 col-lg-6">
                              <div className="mb-2 form-cover">
                                <div
                                  className={` form-group-box-cover ${errors[index]?.assigneeId ? 'form-invalid' : ''}`}>
                                  <label className="label-title d-flex align-items-center mb-0 me-3">Assignee</label>
                                  <Select
                                    options={assigneeOptions}
                                    value={assigneeOptions.find(
                                      (option) =>
                                        option.value === milestone.assigneeId ||
                                        option.value === milestone?.assigneeId?._id
                                    )}
                                    onChange={(option) => handleInputChange(index, 'assigneeId', option.value)}
                                    placeholder="Select"
                                    styles={{
                                      container: (base) => ({
                                        ...base,
                                        maxWidth: '150px'
                                      })
                                    }}
                                  />
                                </div>
                                {errors[index]?.assigneeId && (
                                  <div className="error-message">{errors[index]?.assigneeId}</div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 col-lg-6">
                              <div className="mb-2 form-cover">
                                <div
                                  className={`form-group-box-cover  ${errors[index]?.paymentDue ? 'form-invalid' : ''}`}>
                                  <div className="form-check checkbox label-title d-flex align-items-center me-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`checkboxPayment${index}`}
                                      checked={milestone.paymentDueRequired}
                                      onChange={(e) => handleInputChange(index, 'paymentDueRequired', e.target.checked)}
                                    />
                                    <label className="form-check-label mb-0" htmlFor={`checkboxPayment${index}`}>
                                      Payment Due
                                    </label>
                                  </div>
                                  <div className="form-payment-cover">
                                    <input
                                      type="text"
                                      className="form-payment"
                                      placeholder="$"
                                      maxLength={priceLimit}
                                      value={milestone?.paymentDue ? `$ ${milestone.paymentDue}` : ''}
                                      onChange={(e) => {
                                        let value = e.target.value;

                                        handleInputChange(index, 'paymentDue', value);
                                      }}
                                    />
                                    {/* <p>%</p> */}
                                  </div>
                                </div>
                                {errors[index]?.paymentDue && (
                                  <div className="error-message">{errors[index]?.paymentDue}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end delete-btn">
                          <button
                            type="button"
                            className="btn btn-link"
                            onClick={() => deleteMilestone(index, milestone?._id)}>
                            Delete
                          </button>
                        </div>
                      </>
                    )}
                  </form>
                </div>
              ))}
            </div>
            <div className="d-grid mb-3 mb-sm-4 gap-3">
              <button className="btn addnew-Milestone" type="button" onClick={addMilestone}>
                + Add New Milestone
              </button>
            </div>
          </div>
        </div>

        <div className="col-lg-5 col-md-12">
          <div className="left-sec-content">
            <h2 className="preview">Preview</h2>
            <div className="card-box">
              <div className="inner-card-box">
                <div className="title-content">
                  <h3>{projectDetails.projectName || editProjectDetails.projectName}</h3>
                </div>
                <div className="time-details">
                  {editProjectDetails ? (
                    editProjectDetails?.latestUpdate[0]?.updateStatus?.value == 'late' ? (
                      <h3 className="progress-delaytext">#Late</h3>
                    ) : editProjectDetails?.latestUpdate[0]?.updateStatus?.value == 'early' ? (
                      <h3 className="progress-earlytext">#Early</h3>
                    ) : (
                      <h3>#On-time</h3>
                    )
                  ) : (
                    <h3>#On-time</h3>
                  )}
                </div>
                <div className="time-details"></div>
              </div>
              <div className="card-bottom">
                <div className="milestone-cover">
                  <h5>{formatDate(startDate || new Date(), true)}</h5>
                  <div className="milestone-process"></div>
                  <h5>{formatDate(endDate || new Date(), true)}</h5>
                </div>
              </div>
            </div>
            <div className="overview_updated">
              <div className="cardBox-content-item">
                <div className="milestone-edit">
                  <h4>Milestones</h4>
                </div>

                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="milestoneList">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {milestones.map((milestone, index) => (
                          <Draggable key={index} draggableId={`milestone-${index}`} index={index}>
                            {(provided) => (
                              <div
                                className="design-item design-item-preview"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}>
                                <div className="elipsis-items-cover">
                                  <img src={previewIcon} alt="previewIcon" className="previewIcon-img" />
                                  <div className="elipsis-items-content">
                                    <p className="text-elipsis-items">{milestone.name}</p>
                                    {milestone.dueDate && (
                                      <small>
                                        Due date:{' '}
                                        {formatDate(milestone.dueDate, true, store.currentDateFormat?.toUpperCase())}
                                      </small>
                                    )}
                                  </div>
                                </div>

                                {milestone.daysToComplete && (
                                  <p className="right-aligned">
                                    {milestone.daysToComplete} day
                                    {milestone.daysToComplete > 1 && 's'}
                                  </p>
                                )}
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
           
          </div>
 <div className="buttons-bottom">
              <div className="mt-4 btn-group-milestone">
                {!isWithContract && !isEditing && (
                  <button
                    className="btn-white"
                    type="button"
                    onClick={() => {
                      toggleModal('addProject', true);
                      // createProject(true);
                    }}
                    disabled={!isUpdateEnable}>
                    {!loadingTemplate ? 'Save as Template' : selectLoader(35)}
                  </button>
                )}
                <button
                  className={`btn-black  ${isEditing ? 'w-100' : ''}`}
                  type="button"
                  onClick={() => {
                    createProject(false);
                  }}
                  disabled={loading}
                  aria-busy={loading}>
                  {!loading ? (isEditing ? 'Update Project' : 'Create Project') : selectLoader(35)}
                </button>
              </div>
              {selectedTemplateId && (
                <div className="backTobtn">
                  <button className="btn addnew-Milestone" type="button" onClick={backToTemplate}>
                    Back to Templates
                  </button>
                </div>
              )}
            </div>
        </div>
      </div>
      <SaveModalKanban
        show={modals.addProject}
        onHide={() => {
          toggleModal('addProject', false);
          setTemplateName('');
        }}
        isCreateBoard={false}
        onSave={() => {
          createProject(true);
        }}
        isTemplate={true}
        title={templateName}
        onTitleChange={setTemplateName}
        isLoading={loadingTemplate}
      />
    </div>
  );
};

export default AddTemplate;
